<template>
  <div>
    <a-card class="data-card" title="Introduction">
      <p class="intro">
        These datasets provide comprehensive insights into various levels of cellular processes of breast carcinoma in response to CAP. 
        The omic profiles were sequenced at Jingjie PTM BioLab (Hangzhou) Co. Inc. 
        Please contact Prof. Xiaofeng Dai (email address:  <a href="mailto:xiaofengteam@163.com">xiaofengteam@163.com</a>) for the raw or processed data upon appropriate request if needed.
      </p>
      <div class="image-container">
        <img src="@/assets/data1.png" style="width: 30%;" />
        <div style="width: 4%;"></div>
        <img src="@/assets/data2.png" style="width: 35%;" />
      </div>
    </a-card>
    <a-card class="data-card" title="Dataset" style="margin-top: 50px;">
      <a-table :columns="columns" :dataSource="data" rowKey="id" :pagination="false">
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: 'Omics Data', dataIndex: 'group', key: 'group' },
        { title: 'Sample', dataIndex: 'sample', key: 'sample' },
        { title: 'Cell Line', dataIndex: 'cellLine', key: 'cellLine' },
        { title: 'Treatment', dataIndex: 'treatment', key: 'treatment' },
        { title: 'Classification', dataIndex: 'classification', key: 'classification' },
        { title: 'Repetition', dataIndex: 'repetition', key: 'repetition' }
      ],
      data: [
        {
          id: 1,
          group: 'Acetylome',
          sample: 'Cell',
          cellLine: 'MCF7, SUM159PT',
          treatment: 'Control, CAP',
          classification: 'SUM159PT-Control, SUM159PT-CAP, MCF7-CAP',
          repetition: 3
        },
        {
          id: 2,
          group: 'Lactylome',
          sample: 'Cell',
          cellLine: 'MCF7, SUM159PT',
          treatment: 'Control, CAP',
          classification: 'SUM159PT-Control, SUM159PT-CAP, MCF7-CAP',
          repetition: 3
        },
        {
          id: 3,
          group: 'Phosphorylome',
          sample: 'CDX',
          cellLine: 'SUM159PT Tumor Mouse',
          treatment: 'Control, CAP',
          classification: 'SUM159PT-Control, SUM159PT-CAP',
          repetition: 3
        },
        {
          id: 4,
          group: 'Proteome',
          sample: 'CDX',
          cellLine: 'SUM159PT Tumor Mouse',
          treatment: 'Control, CAP',
          classification: 'SUM159PT-Control, SUM159PT-CAP',
          repetition: 3
        },
        {
          id: 5,
          group: 'Whole transcriptome',
          sample: 'Cell',
          cellLine: 'MCF7, SUM159PT',
          treatment: 'Control, CAP_1h, CAP_8h',
          classification: 'SUM159PT-Control, SUM159PT-CAP_1h, SUM159PT-CAP_8h, MCF7-Control, MCF7-CAP_1h, MCF7-CAP_8h',
          repetition: 3
        }
      ]
    };
  }
};
</script>

<style scoped>
.intro {
  color: #222222;
  width: 98%;
  margin: 10px auto;
  font-size: 17px;
  text-align: justify;
  line-height: 1.8;
}
.image-container {
  display: flex;
  justify-content: center; /* 水平居中对齐容器中的子元素 */
  align-items: center; /* 垂直居中对齐（如果有需要的话） */
}
</style>
